module.exports = __webpack_public_path__ + "img/jrg.bf3efabb.png";